const aboutText = [
  {
    boxTitle: "About me",
    questions: [
      {
        question: "Who am?",
        answer: " My name is Tahrer, I am a Full Stack Developer who believes in making the world a better place by technology."
      },
      {
        question: "Where I am From?",
        answer: " I was born and raised in Jerusalem and currently reside in Haifa."
      },
    ],
  },
  {
    boxTitle: "About the App",
    questions: [
      {
        question: "About the idea",
        answer: "The wild pigs of Haifa have invaded almost all the city. as a stranger, I didn't know where I can be without meeting them.",
      },
      {
        question: "How it is work ?",
        answer: "The app shows all the locations of spotted boars in the last 48 hours, as well as the most affected neighborhoods.",
      },
    ],
  },
  {
    boxTitle: "Next level",
    questions: [
      {
        question: "Short term targets?",
        answer: " To send notifications to subscribers and provide help in emergency cases. (under development)",
      },
      {
        question: "Long term targets?",
        answer: " To collaborate with the authorities and go global.",
      },
    ],
  },
];
export default aboutText;
